import TextareaAutosize from '@mui/material/TextareaAutosize'
import './inputAutoSize_EForm.css'

export default function InputAutoSize_EForm(props) {
    // function splitDecimalString(decimalString) {
    //     // Split the string by the decimal point.
    //     const parts = decimalString.split('.')

    //     // Parse the integer part. If the integer part is empty, return 0.
    //     const integerPart = parseInt(parts[0], 10) || 0

    //     // Handle the fractional part. If it exists, convert it to an integer.
    //     let fractionalPart = 0
    //     if (parts.length > 1 && parts[1]) {
    //         // Assuming you want the fractional part as a whole number
    //         // (e.g., "123.456" returns 456 instead of 0.456)
    //         fractionalPart = parseInt(parts[1], 10)
    //     }

    //     return { integerPart, fractionalPart }
    // }
    // const { integerPart, fractionalPart } = splitDecimalString(
    //     props.question.questionNbr
    // )
    const questionNbr = () => {
        if (props.question.displayMultiQuestionNbr) {
            return props.question.questionNbrCombo
        } else if (props.question.displayQuestionNbr) {
            return props.question.questionNbr
        } else {
            return 0
        }
    }

    const showCenterHeading = () => {
        if (props.question.displayMultiQuestionNbr) {
            return false
        } else if (props.question.displayQuestionNbr) {
            return true
        } else {
            return false
        }
    }

    const maxLen = 1000

    return (
        <div>
            <div className="">
                {props.question.heading ? (
                    <div
                        className=""
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: showCenterHeading()
                                ? 'center'
                                : 'start',
                            fontWeight: 'bold',
                            marginBottom: props.question.isQuestionWithoutAnswer
                                ? '-20px'
                                : '7px',
                        }}>
                        {questionNbr() !== 0 ? (
                            <div style={{ marginRight: '10px' }}>
                                {questionNbr()}.
                            </div>
                        ) : null}

                        <div style={{ textDecoration: 'underline' }}>
                            {props.question.heading}
                        </div>
                    </div>
                ) : null}

                {props.question.questionDescr ? (
                    <div>
                        {questionNbr() !== 0 &&
                        props.question.heading == null ? (
                            <div>{questionNbr()}.</div>
                        ) : null}
                        <div style={{ marginBottom: '5px' }}>
                            {props.question.questionDescr}{' '}
                            {props.question.notes ? (
                                <em>{props.question.notes}</em>
                            ) : null}
                        </div>
                    </div>
                ) : null}

                <div></div>

                {props.validationError ? (
                    <div>
                        <p className="input-autosize-required">* Required</p>
                    </div>
                ) : null}
                {!props.question.isQuestionWithoutAnswer ? (
                    <div>
                        <TextareaAutosize
                            aria-label="empty textarea"
                            disabled={props.disabled}
                            minRows={3}
                            maxLength={props.maxlen ? props.maxlen : maxLen}
                            style={{ width: '100%' }}
                            value={
                                props.question.answer
                                    ? props.question.answer
                                    : ''
                            }
                            onChange={props.onChange}
                        />
                        <div style={{ fontSize: '14px' }}>
                            Current:{' '}
                            {props.question.answer
                                ? props.question.answer.length
                                : 0}{' '}
                            Max: {maxLen}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}
